import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useRestaurantOptions = () => {
  const {
    data: restaurantOptions,
    isLoading: isRestaurantOptionsLoading,
    refetch: refetchRestaurantOptions,
  } = useQuery({
    queryKey: ["restaurantOptions"],
    queryFn: () => dropdownService.getRestaurantOptions(),
  });

  return {
    restaurantOptions: restaurantOptions || [],
    isRestaurantOptionsLoading,
    refetchRestaurantOptions,
  };
};
